interface AspectRatioPreviewProps {
  ratio: string;
  size?: 'sm' | 'md';
}

export function AspectRatioPreview({ ratio, size = 'sm' }: AspectRatioPreviewProps) {
  let widthRatio = 1;
  let heightRatio = 1;

  if (ratio !== 'auto') {
    const parts = ratio.split(':').map(Number);
    widthRatio = parts[0] || 1;
    heightRatio = parts[1] || 1;
  }

  const isLandscape = widthRatio > heightRatio;
  const isSquare = widthRatio === heightRatio;
  const maxSize = size === 'sm' ? 24 : 48;

  let width: number;
  let height: number;

  if (isSquare) {
    width = maxSize;
    height = maxSize;
  } else if (isLandscape) {
    width = maxSize;
    height = (heightRatio / widthRatio) * maxSize;
  } else {
    height = maxSize;
    width = (widthRatio / heightRatio) * maxSize;
  }

  width = Math.max(width, size === 'sm' ? 12 : 20);
  height = Math.max(height, size === 'sm' ? 12 : 20);

  return (
    <div
      className={`border-2 border-current rounded ${ratio === 'auto' ? 'border-dashed' : ''}`}
      style={{ width, height }}
    />
  );
}
